import { rgbToHex } from 'utils/colors/color.utils';
import { parseHexColor } from 'utils/colors/contrastAudit.utils';

// Minimal replacement for `d3.scaleLinear()` used only for color/numeric interpolation.
export function gradientScaleLinear() {
  let _domain = [0, 1];
  let _range = [0, 1];

  function interpolateColor(c1, c2, t) {
    const r = Math.round(c1.r + (c2.r - c1.r) * t);
    const g = Math.round(c1.g + (c2.g - c1.g) * t);
    const b = Math.round(c1.b + (c2.b - c1.b) * t);
    return rgbToHex(r, g, b);
  }

  function scale(x) {
    const d = _domain;
    const r = _range;

    if (d.length < 2 || r.length < 2) return x;

    if (x <= d[0]) return r[0];
    if (x >= d[d.length - 1]) return r[r.length - 1];

    // find segment
    let i = 0;
    while (i < d.length - 1 && x > d[i + 1]) i++;

    const t = (x - d[i]) / (d[i + 1] - d[i]);
    const from = r[i];
    const to = r[i + 1];

    if (typeof from === 'string' && from.startsWith('#')) {
      const c1 = parseHexColor(from);
      const c2 = parseHexColor(to);
      return c1 && c2 ? interpolateColor(c1, c2, t) : from;
    }

    // numeric interpolation
    const n1 = Number(from);
    const n2 = Number(to);
    return n1 + (n2 - n1) * t;
  }

  scale.domain = function (arr) {
    if (!arguments.length) return _domain;
    _domain = arr;
    return scale;
  };

  scale.range = function (arr) {
    if (!arguments.length) return _range;
    _range = arr;
    return scale;
  };

  return scale;
}

// CSS linear-gradient string with each color stop positioned proportionally along the scale's domain.
export const gradientScaleCss = (scale, angle = '90deg') => {
  const domain = scale.domain();
  const range = scale.range();
  const minimum = domain[0];
  const span = domain[domain.length - 1] - minimum;
  const stops = domain.map(
    (value, index) => `${range[index]} ${(((value - minimum) / span) * 100).toFixed(2)}%`,
  );
  return `linear-gradient(${angle}, ${stops.join(', ')})`;
};

export const temperatureColorScale = gradientScaleLinear()
  .domain([-20, -5, 8, 16, 26, 48, 70, 88, 106])
  .range([
    '#401727',
    '#ED0171',
    '#A4059E',
    '#5E0AA9',
    '#2B0C9A',
    '#1083C6',
    '#38BF37',
    '#DCDE00',
    '#FF5B00',
  ]);
